<div class="form">
    <div class="inputs">
        <div class="input-list">
            <div class="input-list-item">
                {{#if label}}<label for="email_input">{{label}}</label>{{/if}}
                <input class="inputs {{email_form_class}}" type="email" id="email_input" placeholder="example@email.com"/>
            </div>
        </div>
    </div>
    <button class="email-button {{button_class}}">{{button_text}}</button>
</div>
